export default __webpack_public_path__ + "static/media/ChargingStationPlaceholder400.05056e7c.png";